module.exports = __webpack_public_path__ + "static/media/Arrow-Right.fed5958c.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/images/Arrow-Right.PNG
// module id = 1224
// module chunks = 1